import React, { useState, useEffect, useRef } from "react";
import { IoMdArrowDropdown } from "react-icons/io";
import { useCookies } from "react-cookie";
import { DebounceInput } from "react-debounce-input";
import { axiosRequest } from "../axiosConfig";
import {
  Box,
  CircularProgress,
  ClickAwayListener,
  IconButton,
  InputAdornment,
  List,
  ListItem,
  ListItemText,
  Paper,
  Popper,
  TextField,
} from "@mui/material";
import { KeyboardArrowDown } from "@mui/icons-material";
import { bgColor } from "../App";

const DropDownWithSearch = (props) => {
  const {
    drpdwn,
    placeholder,
    inputPlaceHolder,
    selectedValue,
    setselectedValue,
    summaryParamsErrorMessage,
    displayedPatient,
  } = props;

  const [searchDropdownPopup, setsearchDropdownPopup] = useState(false);
  const [dropDownList, setDropDownList] = useState([]);
  const outSideRef = useRef(null);
  const [pageSize, setPageSize] = useState(10);
  const [scrollCall, setScrollCall] = useState(false);
  const [searchedText, setSearchedText] = useState("");
  const [SearchLoader, setSearchLoader] = useState(false);
  const [cookies] = useCookies();
  const [anchorEl, setAnchorEl] = useState(null);

  // This is the formate for the date.
  // This is the format for the date.
  function formatDate(date, val) {
    let month = date.getMonth() + 1;
    month = month % 12;
    month = month ? "0" + month : "12";
    let date1 = date.getDate();
    date1 = "0" + date1;
    return month?.slice(-2) + "/" + date1?.slice(-2) + "/" + date.getFullYear();
  }

  const handleScroll = (event) => {
    const target = event.target;

    if (
      drpdwn !== "orderList" &&
      !scrollCall &&
      Math.abs(target.scrollHeight - target.scrollTop - target.clientHeight) < 1
    ) {
      let url = "";
      if (!searchedText) {
        if (drpdwn === "patientList") {
          url = `${process.env.REACT_APP_BaseUrl}patientlist?pageSize=${pageSize}&pageIndex=1`;
        } else if (drpdwn === "orderList") {
          url = `${process.env.REACT_APP_BaseUrl}orderlist?pageSize=${pageSize}&pageIndex=1&id=${displayedPatient}`;
        } else {
          url = `${process.env.REACT_APP_BaseUrl}referringproviderlist?pageSize=${pageSize}&pageIndex=1`;
        }
      } else {
        if (drpdwn === "patientList") {
          url = `${
            process.env.REACT_APP_BaseUrl
          }patientlist?pageSize=${pageSize}&pageIndex=1&searchString=${searchedText
            ?.replaceAll("/", "-")
            ?.replaceAll("%", "%25")}`;
        } else if (drpdwn === "orderList") {
          url = `${
            process.env.REACT_APP_BaseUrl
          }orderlist?pageSize=${pageSize}&pageIndex=1&id=${searchedText?.replaceAll(
            "%",
            "%25",
          )}`;
        } else {
          url = `${
            process.env.REACT_APP_BaseUrl
          }referringproviderlist?pageSize=${pageSize}&pageIndex=1&searchString=${searchedText?.replaceAll(
            "%",
            "%25",
          )}`;
        }
      }

      setSearchLoader(true);
      axiosRequest
        .get(url)
        .then((res) => {
          setSearchLoader(false);
          let data = res?.data?.content;
          let tempData = [];
          if (data) {
            if (drpdwn === "patientList") {
              data?.forEach((element) => {
                tempData.push({
                  name: `${element?.general?.name?.fullName} (${formatDate(
                    new Date(
                      element?.general?.dateOfBirth?.includes("T")
                        ? element?.general?.dateOfBirth
                        : element?.general?.dateOfBirth?.replaceAll("-", "/"),
                    ),
                  )})`,
                  data: element,
                });
              });
            } else if (drpdwn === "orderList") {
              data?.forEach((element) => {
                tempData.push({ name: `${element?.displayId}`, data: element });
              });
            } else {
              data?.forEach((element) => {
                tempData.push({
                  name: `${element?.general?.name?.fullName} (${element?.general?.npi})`,
                  data: element,
                });
              });
            }
            if (pageSize > data?.length) {
              setScrollCall(true);
            }
            setDropDownList((prevList) => [...prevList, ...tempData]);
            setPageSize((prevSize) => prevSize + 10);
          }
        })
        .catch((err) => {
          setSearchLoader(false);
          console.error(err);
          setDropDownList([]);
          setPageSize(0);
        });
    }
  };

  // Drop down auto close event bind and unbind.
  useEffect(() => {
    function handleClickOutside(event) {
      if (outSideRef.current && !outSideRef.current.contains(event.target)) {
        if (searchDropdownPopup) {
          setsearchDropdownPopup(false);
          setDropDownList([]);
        }
      }
    }
    document.addEventListener("click", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("click", handleClickOutside);
    };
  }, [outSideRef, searchDropdownPopup]);

  // This function gives patient list in patient dropdown
  // and orderlist in order dropdown and provider list in provider dropdown.
  const getValuesFromApi = () => {
    let url = "";
    if (props?.drpdwn == "patientList") {
      url = `${process.env.REACT_APP_BaseUrl}patientlist`;
    } else if (props?.drpdwn == "orderList") {
      let patientId = props?.displayedPatient;
      // console.log(patientId,'displayedPatient')
      url = `${process.env.REACT_APP_BaseUrl}orderlist?id=${patientId}`;
    } else {
      url = `${process.env.REACT_APP_BaseUrl}referringproviderlist`;
    }
    setSearchLoader(true);
    axiosRequest
      .get(url)
      .then((res) => {
        setSearchLoader(false);
        let data = res?.data?.content;
        let tempData = [];
        if (data) {
          if (props?.drpdwn == "patientList") {
            data?.forEach((element) => {
              tempData.push({
                name: `${element?.general?.name?.fullName} (${formatDate(
                  new Date(
                    element?.general?.dateOfBirth?.includes("T")
                      ? element?.general?.dateOfBirth
                      : element?.general?.dateOfBirth?.replaceAll("-", "/"),
                  ),
                )})`,
                data: element,
              });
            });
          } else if (props?.drpdwn == "orderList") {
            data?.forEach((element) => {
              tempData.push({ name: `${element?.displayId}`, data: element });
            });
          } else {
            data?.forEach((element) => {
              tempData.push({
                name: `${element?.general?.name?.fullName} (${element?.general?.npi})`,
                data: element,
              });
            });
          }
          setDropDownList([...tempData]);
          let pageS = pageSize + 10;
          setPageSize(pageS);
        }
      })
      .catch((err) => {
        setSearchLoader(false);
        console.log(err, "patientList");
        console.log(err, "orderlist");
        console.log(err, "referringproviderlist");
        setDropDownList([]);
        setPageSize(0);
      });
  };

  // When search dropdown is open then it get the list according to the tab.
  useEffect(() => {
    if (searchDropdownPopup) {
      getValuesFromApi();
    }
  }, [searchDropdownPopup]);

  //This function for search the patient and order and provider according to the tab.
  const searchTextApiCall = (size, inputValue) => {
    let url = "";
    if (props?.drpdwn == "patientList") {
      url = `${
        process.env.REACT_APP_BaseUrl
      }patientlist?pageSize=${size}&pageIndex=1&searchString=${inputValue
        ?.replaceAll("/", "-")
        ?.replaceAll("%", "%25")}`;
    } else if (props?.drpdwn == "orderList") {
      url = `${
        process.env.REACT_APP_BaseUrl
      }orderlist?pageSize=${size}&pageIndex=1&id=${inputValue?.replaceAll(
        "%",
        "%25",
      )}`;
    } else {
      url = `${
        process.env.REACT_APP_BaseUrl
      }referringproviderlist?pageSize=${size}&pageIndex=1&searchString=${inputValue?.replaceAll(
        "%",
        "%25",
      )}`;
    }
    setSearchLoader(true);
    axiosRequest
      .get(url)
      .then((res) => {
        setSearchLoader(false);
        let data = res?.data?.content;
        // console.log(data,"hhh");
        let tempData = [];
        if (data) {
          if (props?.drpdwn == "patientList") {
            data?.forEach((element) => {
              tempData.push({
                name: `${element?.general?.name?.fullName} (${formatDate(
                  new Date(
                    element?.general?.dateOfBirth?.includes("T")
                      ? element?.general?.dateOfBirth
                      : element?.general?.dateOfBirth?.replaceAll("-", "/"),
                  ),
                )})`,
                data: element,
              });
            });
          } else if (props?.drpdwn == "orderList") {
            data?.forEach((element) => {
              tempData.push({ name: `${element?.displayId}`, data: element });
            });
          } else {
            data?.forEach((element) => {
              tempData.push({
                name: `${element?.general?.name?.fullName} (${element?.general?.npi})`,
                data: element,
              });
            });
          }
          setDropDownList([...tempData]);
        }
      })
      .catch((err) => {
        setSearchLoader(false);
        console.log(err, "patientList,orderlist,referringproviderlist");
        setDropDownList([]);
        setPageSize(0);
      });
  };

  // This the function for the search text wich has applied debaunce concept.
  const searchInDropDown = (event) => {
    if (event.target.value && event.target.value?.length > 2) {
      let inputValue = event.target.value?.trim();
      setSearchedText(inputValue);
      searchTextApiCall(10, inputValue);
      setPageSize(10);
    } else if (event.target.value == "") {
      getValuesFromApi();
    }
  };

  // This useEffect used for scroll event, on scroll it calls next list.
  useEffect(() => {
    if (props?.drpdwn !== "orderList") {
      function handleClickOutside1(event) {
        if (
          parseInt(event.target.scrollHeight) -
            parseInt(event.target.scrollTop) ==
          parseInt(event.target.offsetHeight)
        ) {
          let url = "";
          if (!scrollCall) {
            if (!searchedText) {
              if (props?.drpdwn == "patientList") {
                url = `${process.env.REACT_APP_BaseUrl}patientlist?pageSize=${pageSize}&pageIndex=1`;
              } else if (props?.drpdwn == "orderList") {
                url = `${process.env.REACT_APP_BaseUrl}orderlist?pageSize=${pageSize}&pageIndex=1&id=${props?.displayedPatient}`;
              } else {
                url = `${process.env.REACT_APP_BaseUrl}referringproviderlist?pageSize=${pageSize}&pageIndex=1`;
              }
            } else {
              if (props?.drpdwn == "patientList") {
                url = `${
                  process.env.REACT_APP_BaseUrl
                }patientlist?pageSize=${pageSize}&pageIndex=1&searchString=${searchedText
                  ?.replaceAll("/", "-")
                  ?.replaceAll("%", "%25")}`;
              } else if (props?.drpdwn == "orderList") {
                url = `${
                  process.env.REACT_APP_BaseUrl
                }orderlist?pageSize=${pageSize}&pageIndex=1&id=${searchedText?.replaceAll(
                  "%",
                  "%25",
                )}`;
              } else {
                url = `${
                  process.env.REACT_APP_BaseUrl
                }referringproviderlist?pageSize=${pageSize}&pageIndex=1&searchString=${searchedText?.replaceAll(
                  "%",
                  "%25",
                )}`;
              }
            }
            setSearchLoader(true);
            axiosRequest
              .get(url)
              .then((res) => {
                setSearchLoader(false);
                let data = res?.data?.content;
                let tempData = [];
                if (data) {
                  if (props?.drpdwn == "patientList") {
                    data?.forEach((element) => {
                      tempData.push({
                        name: `${
                          element?.general?.name?.fullName
                        } (${formatDate(
                          new Date(
                            element?.general?.dateOfBirth?.includes("T")
                              ? element?.general?.dateOfBirth
                              : element?.general?.dateOfBirth?.replaceAll(
                                  "-",
                                  "/",
                                ),
                          ),
                        )})`,
                        data: element,
                      });
                    });
                  } else if (props?.drpdwn == "orderList") {
                    data?.forEach((element) => {
                      tempData.push({
                        name: `${element?.displayId}`,
                        data: element,
                      });
                    });
                  } else {
                    data?.forEach((element) => {
                      tempData.push({
                        name: `${element?.general?.name?.fullName} (${element?.general?.npi})`,
                        data: element,
                      });
                    });
                  }
                  if (pageSize > data?.length) {
                    setScrollCall(true);
                  }
                  setDropDownList([...tempData]);
                  let pageS = pageSize + 10;
                  setPageSize(pageS);
                }
              })
              .catch((err) => {
                setSearchLoader(false);
                console.log(err, "patientList,orderlist,referringproviderlist");
                setDropDownList([]);
                setPageSize(0);
              });
          }
        }
      }
      const scrollContent = document.querySelector(".list-scroll");
      scrollContent &&
        scrollContent.addEventListener("scroll", handleClickOutside1);
      return () => {
        // Unbind the event listener on clean up
        scrollContent &&
          scrollContent.removeEventListener("scroll", handleClickOutside1);
      };
    }
  }, [searchDropdownPopup, pageSize]);

  const hasError =
    !selectedValue?.data?.id &&
    ((drpdwn === "patientList" && summaryParamsErrorMessage?.selectedPatient) ||
      (drpdwn === "orderList" && summaryParamsErrorMessage?.selectedOrder) ||
      (drpdwn === "providerList" &&
        summaryParamsErrorMessage?.selectedProvider));

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setsearchDropdownPopup(!searchDropdownPopup);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setsearchDropdownPopup(false);
  };

  const getDisplayValue = () => {
    if (selectedValue?.name) {
      return selectedValue.name;
    }
    return placeholder;
  };

  const bgColor = "rgb(210 210 210 / 10%)";
  const bgColorStyles = {
    "& .MuiFilledInput-root": {
      bgcolor: bgColor,
    },
  };

  return (
    <Box ref={outSideRef}>
      <TextField
        fullWidth
        size="small"
        error={hasError}
        variant="filled"
        value={getDisplayValue()}
        onClick={handleClick}
        sx={{
          "& .MuiInputBase-root": { cursor: "pointer" }, // This styles the input container
          "& .MuiInputBase-input": { cursor: "pointer" }, // This styles the input element itself
          ...bgColorStyles,
        }}
        InputProps={{
          readOnly: true,
          endAdornment: (
            <InputAdornment position="end">
              <IconButton edge="end">
                <KeyboardArrowDown />
              </IconButton>
            </InputAdornment>
          ),
        }}
      />

      <Popper
        open={searchDropdownPopup}
        anchorEl={anchorEl}
        placement="bottom-start"
        style={{ width: anchorEl?.offsetWidth, zIndex: 1300 }}
      >
        <ClickAwayListener onClickAway={handleClose}>
          <Paper elevation={3}>
            <Box p={2}>
              <DebounceInput
                element={TextField}
                debounceTimeout={1000}
                fullWidth
                placeholder={inputPlaceHolder}
                onChange={(e) => searchInDropDown(e)}
                autoFocus
                size="small"
              />

              <List
                className="list-scroll"
                sx={{
                  maxHeight: 250,
                  overflow: "auto",
                  mt: 1,
                }}
                onScroll={handleScroll}
              >
                {dropDownList?.length > 0
                  ? dropDownList.map((elem, ind) => (
                      <ListItem
                        key={ind}
                        button
                        selected={elem.name === selectedValue?.name}
                        onClick={() => {
                          setselectedValue(elem);
                          handleClose();
                        }}
                      >
                        <ListItemText
                          primary={elem.name}
                          sx={{
                            color:
                              elem.name === selectedValue?.name
                                ? "primary.main"
                                : "inherit",
                          }}
                        />
                      </ListItem>
                    ))
                  : null}
              </List>

              {SearchLoader && (
                <Box
                  sx={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "rgba(255, 255, 255, 0.7)",
                  }}
                >
                  <CircularProgress size={24} />
                </Box>
              )}
            </Box>
          </Paper>
        </ClickAwayListener>
      </Popper>
    </Box>
  );
};
export default DropDownWithSearch;
